import { ReactElement } from 'react';
import {
    UserSituationBooleanValue,
    UserSituationWhatIsYourCurrentPropertyGoalValue
} from '../../graphql.generated';

export type YourSituationResultProps = {
    goal?: string | null;
    question: string | null;
};

export type YourSituationProps = {
    questionsMap: QuestionsMap;
    firstQuestionId: QuestionNames;
    analyticsPage: string;
    initialValues?: Record<string, string | null | undefined> | undefined;
    actionAfterQuestionsElement?: ReactElement;
    showEditButton?: boolean;
    saveData?: (data: AnswerData) => Promise<void>;
    onFirstQuestionSaved?: () => void;
    onResults?: (currentSteps: string[]) => void;
    forceFormMode?: 'force_edit' | 'force_reset';
    initialLoadAsDone?: boolean;
    trackingIdentifier?: string;
};

const QUESTION_NAMES = [
    'situationWhatIsYourCurrentPropertyGoal',
    'situationAreYouAFirstTimeBuyer',
    'situationAreYouSellingAProperty',
    'situationIsItAlreadyOnTheMarket',
    'situationAreYouAPropertyInvestor',
    'situationAreYouLookingToBuy',
    'situationAreYouAHomeowner'
] as const;

export type QuestionNames = (typeof QUESTION_NAMES)[number];

type QuestionsMap = {
    [key in QuestionNames]: QuestionStep;
};

export type QuestionStep = {
    label: string;
    options: {
        id: string;
        value: string;
        label: string;
    }[];
    subtitle?: string;
    getNext: (value: string, situationBranch: string) => string | 'done';
    formatAnswer: (answer: { value: string; label: string }) => string;
};

export type AnswerData = Record<string, string | undefined | null>;

export const checkIsQuestionNames = (
    string: string
): string is QuestionNames => {
    const stringArray: string[] = [...QUESTION_NAMES];
    return stringArray.includes(string);
};

const isEnumMember = <T extends Record<string, string>>(
    enumerator: T,
    value: string
): value is T[keyof T] => {
    for (const k in enumerator) {
        if (enumerator[k] === value) {
            return true;
        }
    }

    return false;
};

export const checkIsGoalValue = (
    value: string
): value is UserSituationWhatIsYourCurrentPropertyGoalValue => {
    return isEnumMember(UserSituationWhatIsYourCurrentPropertyGoalValue, value);
};

export const checkIsSituationValue = (
    value: string
): value is UserSituationBooleanValue => {
    return isEnumMember(UserSituationBooleanValue, value);
};
